<template>
  <div>
    <div class="text-center">
      <v-btn
        outlined
        color="primary"
        @click="showEmailForm = !showEmailForm;"
      >
        Notify Stakeholders
      </v-btn>
    </div>
    <v-container
      v-if="showEmailForm"
      id="email"
    >
      <v-alert
        v-model="emailError"
        type="error"
        :dismissible="true"
        class="mb-4"
      >
        Something went wrong, try again later
      </v-alert>
      <v-alert
        v-model="emailSuccess"
        type="success"
        :dismissible="true"
        class="mb-4"
      >
        Success, email sent!
      </v-alert>
      <v-alert
        v-model="emailWarning"
        type="warning"
        :dismissible="true"
        class="mb-4"
      >
        Please fill out all fields
      </v-alert>
      <v-text-field
        v-model="mail.subject"
        outlined
        required
        :error-messages="subjectError"
        label="Subject"
        @input="$v.mail.subject.$touch()"
        @blur="$v.mail.subject.$touch()"
      />
      <v-textarea
        v-model="mail.body"
        outlined
        rows="10"
        auto-grow
        :error-messages="bodyError"
        label="Body"
        @input="$v.mail.body.$touch()"
        @blur="$v.mail.body.$touch()"
      />
      <div class="text-xs-right">
        <v-btn
          color="primary"
          @click="sendEmail()"
        >
          Send
        </v-btn>
        <v-progress-circular
          v-if="emailLoading"
          indeterminate
          color="primary"
        />
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  data() {
    return {
      showEmailForm: false,
      emailError: false,
      emailSuccess: false,
      emailWarning: false,
      emailLoading: false,
      mail: {
        body: "",
        subject: ""
      },
    }
  },
  computed: {
    subjectError() {
      const errors = [];
      if (!this.$v.mail.subject.$dirty) {
        return errors;
      }
      !this.$v.mail.subject.required && errors.push("Subject is required.");
      return errors;
    },
    bodyError() {
      const errors = [];
      if (!this.$v.mail.body.$dirty) {
        return errors;
      }
      !this.$v.mail.body.required && errors.push("Body is required.");
      return errors;
    }
  },
  validations: {
    mail: {
      subject: { required },
      body: { required }
    }
  },
  watch: {
    showEmailForm: function() {
      this.resetFields();
      this.alertToggle(false, false, false);
      setTimeout(function() {
        let emailBox = document.getElementById("email");
        if (emailBox !== null) {
          emailBox.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }, 100);
    },
  },
  methods: {
    ...mapActions({
      emailAllStakeholders: "stakeholders/emailAllStakeholders",
    }),
    alertToggle(success, error, warning) {
      (this.emailSuccess = success),
      (this.emailError = error),
      (this.emailWarning = warning);
    },
    resetFields() {
      this.$v.$reset();
      this.mail.subject = "";
      this.mail.body = "";
    },
    sendEmail() {
      this.alertToggle(false, false, false);
      /*eslint-disable */
            let message = {
                subject: this.mail.subject,
                body: this.mail.body
            };
            /* eslint-enable */
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.alertToggle(false, false, true);
      } else {
        this.emailLoading = true;
        this.emailAllStakeholders(message)
          .then(() => {
            this.emailLoading = false;
            this.alertToggle(true, false, false);
            this.resetFields();
          })
          .catch(() => {
            this.alertToggle(false, true, false);
            this.emailLoading = false;
          });
      }
    }
  },
}
</script>